import { graphql } from "@/gql";

export const coachViewerQuery = graphql(`
  query CoachViewer($currentDate: ISO8601Date!) {
    coachViewer {
      ...Coach
    }
    ...ClientAppointments
  }
`);

export const foodJournalingClientsQuery = graphql(`
  query FoodJournalingClients(
    $currentDate: ISO8601Date!
    $orderByName: OrderByDirection
    $searchKey: String
    $statuses: [String!]
  ) {
    foodJournalingClients(
      orderByName: $orderByName
      name: $searchKey
      statuses: $statuses
    ) {
      nodes {
        ...Client
      }
    }
  }
`);

export const weightLoggingClientsQuery = graphql(`
  query WeightLoggingClients(
    $currentDate: ISO8601Date!
    $orderByName: OrderByDirection
    $searchKey: String
    $statuses: [String!]
  ) {
    weightLoggingClients(
      orderByName: $orderByName
      name: $searchKey
      statuses: $statuses
    ) {
      nodes {
        ...Client
      }
    }
  }
`);

export const moduleAnsweringClientsQuery = graphql(`
  query ModuleAnsweringClients(
    $currentDate: ISO8601Date!
    $orderByName: OrderByDirection
    $searchKey: String
    $statuses: [String!]
  ) {
    moduleAnsweringClients(
      orderByName: $orderByName
      name: $searchKey
      statuses: $statuses
    ) {
      nodes {
        ...Client
      }
    }
  }
`);
